var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.20009,
    cy: 1.20009,
    r: 1.20009,
    fill: "#99A0A8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.39732,
    cy: 1.20009,
    r: 1.20009,
    fill: "#99A0A8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.20009,
    cy: 5.99696,
    r: 1.20009,
    fill: "#99A0A8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.39735,
    cy: 5.99696,
    r: 1.20009,
    fill: "#99A0A8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.20009,
    cy: 10.8016,
    r: 1.20009,
    fill: "#99A0A8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.39735,
    cy: 10.8016,
    r: 1.20009,
    fill: "#99A0A8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.89a7540470922f424a047f2540920fe6.svg";
export { ForwardRef as ReactComponent };